import { SearchObject } from "app/common/Model/SearchObject";
import { searchTreatmentPlanCardReport } from "app/services/TreatmentPlanCardService";
import { exportReportCardItem } from "app/services/VoucherService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";
export default class ReportRegisterCardStore {
  listDataReportCard = null;
  searchReportCard = {
    ...new SearchObject(),
    fromDate: new Date(),
    toDate: new Date(),
    type: 1,
    listDepId: null,
    clientCardId: null,
    clientCardGroupId: null,
    phoneNumber: null,
    patientName: null,
    patientCode: null,
  };
  constructor() {
    makeAutoObservable(this);
  }

  handleChangeFormSearchReportCard = (searchReportCard) => {
    this.searchReportCard = {
      ...this.searchReportCard,
      ...searchReportCard,
    };
    this.pagingReportCard();
  };

  pagingReportCard = async () => {
    let {
      listDepId,
      clientCardId,
      clientCardGroupId,
      phoneNumber,
      patientName,
      patientCode,
      ...ortherData
    } = this.searchReportCard;
    
    // Không call API nếu không có cơ sở (bắt buộc)
    if (!listDepId || listDepId.length === 0) {
      this.listDataReportCard = null;
      return;
    }
    
    if (listDepId) {
      ortherData.listDepId = listDepId?.map((el) => el?.id);
    } else {
      ortherData.listDepId = null;
    }
    if (clientCardId) {
      ortherData.clientCardId = clientCardId?.id;
    }
    if (clientCardGroupId) {
      ortherData.clientCardGroupId = clientCardGroupId?.id;
    }
    if (phoneNumber) {
      ortherData.phoneNumber = phoneNumber;
    }
    if (patientName) {
      ortherData.patientName = patientName;
    }
    if (patientCode) {
      ortherData.patientCode = patientCode;
    }
    return await searchTreatmentPlanCardReport({ ...ortherData })
      .then(({ data }) => {
        this.listDataReportCard = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu thẻ trả trước có lỗi");
      });
  };
  handleExportRegisterCard = async (searchObj) => {
    if (!(searchObj?.listDepId?.length > 0)) {
      toast.error("Vui lòng chọn cơ sở để xuất excel");
      return;
    }
    const search = { ...this.normalizeSearchReportCard(searchObj) };
    try {
      const response = await exportReportCardItem(search);
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "BAO_CAO_DANG_KI_THE_TRA_TRUOC.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error export excel report:", error);
    }
  };

  normalizeSearchReportCard = (rawSearch = {}) => {
    const { listDepId, ...rest } = rawSearch;
    return {
      ...rest,
      listDepId: listDepId?.map((el) => el?.id),
    };
  };
  resetStore = () => {
    this.listDataReportCard = null;
    this.searchReportCard = {
      ...new SearchObject(),
      fromDate: new Date(),
      toDate: new Date(),
      type: 1,
      listDepId: null,
      clientCardId: null,
      clientCardGroupId: null,
      phoneNumber: null,
      patientName: null,
      patientCode: null,
    };
  };
}
